






import { Component, Prop, Vue } from 'vue-property-decorator';
import { TextBlockDto } from '@/api';
import { CmsVariableResolver } from '@/util/CmsVariableResolver';

@Component
export default class TextBlock extends Vue {
  @Prop({required: true})
  public readonly model!: TextBlockDto;

  get content(): string {
    return CmsVariableResolver.resolve(this.model.content);
  }

  public async mounted() {
    this.$nextTick(() => {
        const linkElements = this.$el.querySelectorAll('a');
        linkElements.forEach((linkElement) => {
            const href = linkElement.getAttribute('href');
            if (href && !this.isLinkExternal(href.toString())) {
              linkElement.target = '_self';
            }
          },
        );
      },
    );
  }

  private isLinkExternal(link: string): boolean {
    return link.startsWith('http');
  }
}
